import React,{useContext,useEffect} from 'react'
import {HeadTableLeads, RowLeadsdiscarded} from "../../ui-components";
import LeadsContext from '../../context/leads';


function DiscardedTable({order}) {
  const {Leadslist, models, Subs} = useContext(LeadsContext)

  useEffect(()=>{
    Leadslist(2, order);
    Subs();
  },[order])

  return (
    <div className="overflow-x-scroll py-2">
    <HeadTableLeads type="discarded"/>
    {models?.map((lead, index) => (
      index % 2 == 0 ?
      <RowLeadsdiscarded key={lead.id} leads={lead} /> :
      <RowLeadsdiscarded key={lead.id} leads={lead} overrides={{
        "Frame 20797":{backgroundColor: "#ffffff"}
      }}/> 
    ))}
  </div>

  )
}

export default DiscardedTable